module.exports = __webpack_public_path__ + "img/8.1c860803.jpg";